import {
    put, takeLatest, call
} from 'redux-saga/effects';
import { axios } from '../client';
import {
    createPaymentIntent, STRIPE_CREATE_PAYMENT_INTENT,
    updatePaymentIntent, STRIPE_UPDATE_PAYMENT_INTENT, STRIPE_UPDATE_BILLING_ADDRESS, updateBillingAddress
} from "../actions/stripe";


function* handleCreatePaymentIntent({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    try {
        const params = new URLSearchParams();
        params.append('amount', Math.round(payload.amount));
        params.append('idempotency_key', payload.idempotencyKey);

        const response = yield call(axios.post, `${window.api_url}/site/payment/intent`, params);

        yield put(createPaymentIntent({
            createPaymentIntentSuccess: true,
            paymentIntentClientSecret: response.data.data.client_secret
        }, {'sent': true}));

    } catch (error) {
        yield put(createPaymentIntent(error, {}, true));
    }
}
export function* watchCreatePaymentIntent() {
    yield takeLatest(STRIPE_CREATE_PAYMENT_INTENT, handleCreatePaymentIntent);
}


function* handleUpdatePaymentIntent({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    try {
        const params = new URLSearchParams();
        params.append('amount', Math.round(payload.amount));

        yield call(axios.post, `${window.api_url}/site/payment/intent/${payload.paymentIntentId}`, params);

        yield put(updatePaymentIntent({
            updatePaymentIntentSuccess: true,
        }, {'sent': true}));

    } catch (error) {
        yield put(updatePaymentIntent(error, {}, true));
    }
}
export function* watchUpdatePaymentIntent() {
    yield takeLatest(STRIPE_UPDATE_PAYMENT_INTENT, handleUpdatePaymentIntent);
}



function* handleUpdateBillingAddress({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    try {
        const params = new URLSearchParams();
        params.append('payment_method_id', payload.payment_method_id);
        params.append('address_line1', payload.address_line1);
        params.append('address_line2', payload.address_line2);
        params.append('locality', payload.locality);
        params.append('region', payload.region);
        params.append('postal_code', payload.postal_code);

        yield call(axios.post, `${window.react_giftya_base_url}/secure/stripe/update-payment-method-billing-address`, params);

        yield put(updateBillingAddress({
            updateBillingAddressSuccess: true,
        }, {'sent': true}));

    } catch (error) {
        yield put(updateBillingAddress(error, {}, true));
    }
}
export function* watchUpdateBillingAddress() {
    yield takeLatest(STRIPE_UPDATE_BILLING_ADDRESS, handleUpdateBillingAddress);
}